(function () {
  'use strict';

  /* ── State ─────────────────────────────────────────────────────────── */
  var manifest = [];   // [{type, src, thumbSrc, alt, template}]
  var current  = 0;
  var isOpen   = false;
  var touchStartX = 0;
  var navTimer = null;

  /* ── DOM refs ──────────────────────────────────────────────────────── */
  var lb, backdrop, imgEl, videoEl, modelEl,
      counter, numEl, badge3d,
      closeBtn, prevBtn, nextBtn,
      strip, mediaWrap;

  /* ── Media type helper ─────────────────────────────────────────────── */
  function getMediaType(containerEl) {
    if (containerEl.classList.contains('product-media-container--model'))          return 'model';
    if (containerEl.classList.contains('product-media-container--video'))          return 'video';
    if (containerEl.classList.contains('product-media-container--external_video')) return 'video';
    return 'image';
  }

  /* ── Thumbnail src helper ──────────────────────────────────────────── */
  function getThumbSrc(containerEl, index) {
    var thumbBtns = document.querySelectorAll('.swiper-controls__thumbnail');
    var btn = thumbBtns[index];
    var img = btn ? btn.querySelector('img') : null;
    if (img && (img.currentSrc || img.src)) return img.currentSrc || img.src;
    img = containerEl.querySelector('img');
    return img ? (img.currentSrc || img.src || '') : '';
  }

  /* ── Build manifest from DOM ───────────────────────────────────────── */
  function buildManifest() {
    var containers = document.querySelectorAll('.product-media-container--slide');
    manifest = Array.from(containers).map(function (el, i) {
      var type     = getMediaType(el);
      var thumbSrc = getThumbSrc(el, i);

      if (type === 'image') {
        var imgTag = el.querySelector('img[data_max_resolution]');
        return {
          type:     'image',
          src:      imgTag ? imgTag.getAttribute('data_max_resolution') : thumbSrc,
          thumbSrc: thumbSrc,
          alt:      imgTag ? (imgTag.alt || '') : ''
        };
      }

      if (type === 'video') {
        var tmpl = el.querySelector('deferred-media template') ||
                   el.querySelector('template');
        return {
          type:     'video',
          thumbSrc: thumbSrc,
          template: tmpl ? tmpl.innerHTML : ''
        };
      }

      if (type === 'model') {
        var tmpl = el.querySelector('product-model template') ||
                   el.querySelector('template');
        return {
          type:     'model',
          thumbSrc: thumbSrc,
          template: tmpl ? tmpl.innerHTML : ''
        };
      }

      return { type: 'image', src: thumbSrc, thumbSrc: thumbSrc, alt: '' };
    });
  }

  /* ── Build filmstrip ────────────────────────────────────────────────── */
  function buildFilmstrip() {
    strip.innerHTML = manifest.map(function (item, i) {
      var badges = '';
      if (item.type === 'video') {
        badges = '<span class="e3-lb__tn-play-bg" aria-hidden="true"></span>'
               + '<span class="e3-lb__tn-badge e3-lb__tn-badge--video" aria-hidden="true">&#9654;</span>';
      } else if (item.type === 'model') {
        badges = '<span class="e3-lb__tn-badge e3-lb__tn-badge--3d" aria-hidden="true">3D</span>';
      }
      return '<button class="e3-lb__tn" data-index="' + i + '" type="button"'
           + ' aria-label="View media ' + (i + 1) + '">'
           + '<img src="' + item.thumbSrc + '" alt="" loading="lazy">'
           + badges
           + '</button>';
    }).join('');

    strip.querySelectorAll('.e3-lb__tn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        navigate(parseInt(btn.dataset.index, 10));
      });
    });
  }

  /* ── Render media for current index ────────────────────────────────── */
  function renderMedia(index) {
    var item = manifest[index];
    if (!item) return;

    imgEl.hidden   = true;
    videoEl.hidden = true;
    modelEl.hidden = true;

    if (item.type === 'image') {
      imgEl.src    = item.src;
      imgEl.alt    = item.alt;
      imgEl.hidden = false;

    } else if (item.type === 'video') {
      renderVideo(item);

    } else if (item.type === 'model') {
      renderModel(item);
    }
  }

  /* ── Video rendering ────────────────────────────────────────────────── */
  function renderVideo(item) {
    var parser = new DOMParser();
    var doc    = parser.parseFromString(item.template, 'text/html');
    var iframeTag = doc.querySelector('iframe');
    var videoTag  = doc.querySelector('video');

    if (iframeTag) {
      var srcAttr = iframeTag.getAttribute('src') || '';
      try {
        var url = new URL(srcAttr, window.location.origin);
        url.searchParams.set('autoplay', '0');
        srcAttr = url.toString();
      } catch (e) { /* non-critical — keep original src */ }

      var frame = document.createElement('iframe');
      frame.src             = srcAttr;
      frame.allow           = 'accelerometer; gyroscope; picture-in-picture; fullscreen';
      frame.allowFullscreen = true;
      frame.className       = 'e3-lb__video-iframe';
      videoEl.appendChild(frame);

    } else if (videoTag) {
      var v = videoTag.cloneNode(true);
      v.removeAttribute('autoplay');
      v.controls  = true;
      v.className = 'e3-lb__video-native';
      videoEl.appendChild(v);
    }

    videoEl.hidden = false;
  }

  /* ── 3D model rendering ─────────────────────────────────────────────── */
  function renderModel(item) {
    var parser = new DOMParser();
    var doc    = parser.parseFromString(item.template, 'text/html');
    var mv     = doc.querySelector('model-viewer');

    if (mv) {
      var clone = mv.cloneNode(true);
      clone.className        = 'e3-lb__model-viewer';
      clone.style.width      = '100%';
      clone.style.height     = '100%';
      clone.style.background = 'transparent';
      modelEl.appendChild(clone);
    }

    var hint = document.createElement('div');
    hint.className   = 'e3-lb__model-hint';
    hint.textContent = '↻ Drag to rotate · Pinch to zoom';
    modelEl.appendChild(hint);

    modelEl.hidden = false;
  }

  /* ── Teardown media ──────────────────────────────────────────────────── */
  function teardownMedia() {
    var frame = videoEl.querySelector('iframe');
    if (frame) frame.src = '';
    videoEl.innerHTML = '';
    modelEl.innerHTML = '';
    imgEl.removeAttribute('src');
    imgEl.hidden = true;
  }

  /* ── Update counter + arrows + filmstrip active ───────────────────── */
  function updateChrome() {
    var item  = manifest[current];
    var total = manifest.length;

    numEl.textContent = (current + 1) + ' / ' + total;
    badge3d.hidden    = item.type !== 'model';

    prevBtn.classList.toggle('e3-lb__arrow--hidden', current === 0);
    prevBtn.setAttribute('aria-hidden', current === 0 ? 'true' : 'false');
    prevBtn.tabIndex = current === 0 ? -1 : 0;

    nextBtn.classList.toggle('e3-lb__arrow--hidden', current === manifest.length - 1);
    nextBtn.setAttribute('aria-hidden', current === manifest.length - 1 ? 'true' : 'false');
    nextBtn.tabIndex = current === manifest.length - 1 ? -1 : 0;

    strip.querySelectorAll('.e3-lb__tn').forEach(function (btn, i) {
      btn.classList.toggle('e3-lb__tn--active', i === current);
      btn.setAttribute('aria-pressed', i === current ? 'true' : 'false');
    });
  }

  /* ── Focus trap helpers ─────────────────────────────────────────────── */
  function getFocusable() {
    return Array.from(lb.querySelectorAll(
      'button:not([tabindex="-1"]), [tabindex="0"]'
    )).filter(function (el) {
      return !el.closest('[hidden]') && getComputedStyle(el).visibility !== 'hidden';
    });
  }

  /* ── Open ────────────────────────────────────────────────────────────── */
  function open(index) {
    if (!manifest.length) return;
    current = Math.max(0, Math.min(index, manifest.length - 1));
    isOpen  = true;

    lb.hidden = false;
    document.body.classList.add('e3-lb-open');

    requestAnimationFrame(function () {
      lb.classList.add('e3-lb--visible');
    });

    renderMedia(current);
    updateChrome();
    closeBtn.focus();
  }

  /* ── Close ───────────────────────────────────────────────────────────── */
  function close() {
    if (!isOpen) return;
    isOpen = false;

    lb.classList.remove('e3-lb--visible');
    document.body.classList.remove('e3-lb-open');

    var closeTimer = setTimeout(function () {
      lb.hidden = true;
      teardownMedia();
    }, 400);
    lb.addEventListener('transitionend', function () {
      clearTimeout(closeTimer);
      lb.hidden = true;
      teardownMedia();
    }, { once: true });
  }

  /* ── Navigate ────────────────────────────────────────────────────────── */
  function navigate(index) {
    if (index < 0 || index >= manifest.length) return;

    clearTimeout(navTimer);
    mediaWrap.style.opacity = '0';

    navTimer = setTimeout(function () {
      teardownMedia();
      current = index;
      renderMedia(current);
      updateChrome();
      requestAnimationFrame(function () {
        mediaWrap.style.opacity = '';
      });
    }, 120);
  }

  /* ── Keyboard handler (includes focus trap) ─────────────────────────── */
  function onKeydown(e) {
    if (!isOpen) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }

    if (e.key === 'ArrowLeft')  { e.preventDefault(); navigate(current - 1); return; }
    if (e.key === 'ArrowRight') { e.preventDefault(); navigate(current + 1); return; }

    if (e.key === 'Tab') {
      var focusable = getFocusable();
      if (!focusable.length) { e.preventDefault(); return; }
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  }

  /* ── Touch swipe ─────────────────────────────────────────────────────── */
  function onTouchStart(e) {
    touchStartX = e.touches[0].clientX;
  }

  function onTouchEnd(e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > 50) {
      navigate(dx < 0 ? current + 1 : current - 1);
    }
  }

  /* ── Intercept Ella's zoom-dialog clicks ────────────────────────────── */
  function interceptZoomTrigger() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-zoom-index]');
      if (!trigger) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      open(parseInt(trigger.dataset.zoomIndex, 10));
    }, true); /* capture phase — fires before ZoomDialog.connectedCallback listener */
  }

  /* ── Init ────────────────────────────────────────────────────────────── */
  function init() {
    if (!document.querySelector('.product-media-container--slide')) return;

    lb        = document.getElementById('e3-lightbox');
    backdrop  = document.getElementById('e3-lb-backdrop');
    imgEl     = document.getElementById('e3-lb-img');
    videoEl   = document.getElementById('e3-lb-video');
    modelEl   = document.getElementById('e3-lb-model');
    counter   = document.getElementById('e3-lb-counter');
    numEl     = document.getElementById('e3-lb-num');
    badge3d   = document.getElementById('e3-lb-3d-badge');
    closeBtn  = document.getElementById('e3-lb-close');
    prevBtn   = document.getElementById('e3-lb-prev');
    nextBtn   = document.getElementById('e3-lb-next');
    strip     = document.getElementById('e3-lb-strip');
    mediaWrap = document.getElementById('e3-lb-media-wrap');

    if (!lb) return;

    buildManifest();
    if (!manifest.length) return;

    buildFilmstrip();
    interceptZoomTrigger();

    closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { navigate(current - 1); });
    nextBtn.addEventListener('click', function () { navigate(current + 1); });

    document.addEventListener('keydown', onKeydown);
    mediaWrap.addEventListener('touchstart', onTouchStart, { passive: true });
    mediaWrap.addEventListener('touchend',   onTouchEnd,   { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
